export const wrapperIdentifier = 'institutions';

export interface Institution {
  identifier: string;
  name: string;
}
